
/* @ngInject */
function searchFilters1Controller($scope, $attrs, $stateParams, $location, $timeout, $anchorScroll, $window, $rootScope, raSpinnerService, productLookupService, productFilterService, orderByFilter, optionsPopupService) {
    const vm = this;
    const MINIMUM_DISPLAYED_LIST_LENGTH = 7;
    let checkboxTimeout;

    vm.currentFilter = $scope.currentFilter;
    vm.currentFilterTypeId = vm.currentFilter.TypeId;
    vm.currentFilter.showFilter = true;

    // run on init
    function init() {
        addOptionAttributes();
        updateFilterFromURL();

        if ($scope.last) {
            $rootScope.$broadcast('searchFiltersDirective.filtersLoaded');
        }
    }
    init();


    function addOptionAttributes() {
        // Add attributes to all checkbox options
        vm.currentFilter.InputOptions = orderByFilter(vm.currentFilter.InputOptions, '+DisplayName');
        for (const options in vm.currentFilter.InputOptions) {
            const optn = vm.currentFilter.InputOptions[options];
            optn.optionID = `${vm.currentFilter.Deprecated_ProductAttributeNameId}-${options}`;
            optn.isChecked = false;
            optn.letter = optn.DisplayName.charAt(0);
        }

        // Find matching object in productFilterService and copy entire filter back in for a clean version
        for (const filter in productFilterService.productTypeFilters) {
            if (productFilterService.productTypeFilters[filter].Deprecated_ProductAttributeNameId === vm.currentFilter.Deprecated_ProductAttributeNameId) {
                productFilterService.productTypeFiltersClean[filter] = angular.copy(vm.currentFilter);
            }
        }
    }

    function updateFilterFromURL() {
        const currentFilter = vm.currentFilter;
        const values = $scope.getFilterURLValues(currentFilter)[0].values;

        if (currentFilter.InputOptions) {
            // loop through the checkbox options and set checked true where value is matched
            for (let i = 0; i < currentFilter.InputOptions.length; i++) {
                for (let j = 0; j < values.length; j++) {
                    if (currentFilter.InputOptions[i].DisplayName === values[j]) {
                        currentFilter.InputOptions[i].isChecked = true;
                        break;
                    }
                }
            }

            const optionsChecked = [];
            const optionsNotChecked = [];

            for (let k = 0; k < currentFilter.InputOptions.length; k++) {
                // js lint complained about a ternary that doesn't assign any result..
                if (currentFilter.InputOptions[k].isChecked) {
                    optionsChecked.push(currentFilter.InputOptions[k]);
                } else {
                    optionsNotChecked.push(currentFilter.InputOptions[k]);
                }
            }

            // concatenate checked and not checked, do not do this on numeric range inputs
            currentFilter.InputOptions = optionsChecked.concat(optionsNotChecked);
            currentFilter.DisplayLimit = optionsChecked.length > MINIMUM_DISPLAYED_LIST_LENGTH ? optionsChecked.length : currentFilter.DisplayLimit;
        }
    }

    (function checkFilterShow() {
        if (typeof vm.currentFilter.InputOptions === 'undefined' || vm.currentFilter.InputOptions !== null) {
            vm.currentFilter.showFilter = true;
        } else if (vm.currentFilter.InputOptions === null) {
            vm.currentFilter.showFilter = false;
        }
    }());

    // Function to pass options from "vew all" link to popup box, then alphabetize
    vm.showOptionsPopup = function () {
        optionsPopupService.setPopupData({
            currentFilter: vm.currentFilter,
            alphabeticalOptions: orderByFilter(vm.currentFilter.InputOptions, '+DisplayName'),
        });
        $rootScope.$broadcast('searchFilters.showOptionsPopup');
    };

    vm.checkboxChanged = function () {
        $timeout.cancel(checkboxTimeout);

        checkboxTimeout = $timeout(() => {
            $scope.processFilter();
        }, 500);
    };
}

export default function searchFilters1Directive() {
    return {
        restrict: 'E',
        templateUrl: 'app/productCenter/pages/productsearch/searchFilters/templates/checkbox.html',
        controller: searchFilters1Controller,
        controllerAs: 'searchFilter',
    };
}




// WEBPACK FOOTER //
// ./src/app/productCenter/pages/productsearch/searchFilters/directives/searchFilterCheckbox.directive.js